export default __webpack_public_path__ + "static/media/salesforceSoftDecline.30a83560.png";